import React from "react";
import img1 from "../../../Assets/Homeimgs/image-1.png";
import img2 from "../../../Assets/Homeimgs/image-2.png";
import img3 from "../../../Assets/Homeimgs/image-3.png";
import img4 from "../../../Assets/Homeimgs/image-4.png";
import img5 from "../../../Assets/Homeimgs/image-5.png";
import img6 from "../../../Assets/Homeimgs/image-14.png";
import img7 from "../../../Assets/Homeimgs/image-6.png";
import img8 from "../../../Assets/Homeimgs/image-7.png";
import img9 from "../../../Assets/Homeimgs/image-8.png";
import img10 from "../../../Assets/Homeimgs/image-9.png";
import img11 from "../../../Assets/Homeimgs/image-10.png";
import img12 from "../../../Assets/Homeimgs/image-11.png";
import img13 from "../../../Assets/Homeimgs/image-12.png";
import img14 from "../../../Assets/Homeimgs/image-13.png";
import img15 from "../../../Assets/Homeimgs/image-15.png";

const logos = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
];

const TrustedBy = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-12 lg:py-16">
      {/* Background design */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div
          className="text-center mb-10"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <p
            className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-sm text-[#5989C8] font-medium backdrop-blur-md"
            data-aos="zoom-out-right"
          >
            Trusted By
          </p>
          <h1 className="text-2xl mt-4 md:text-4xl font-semibold text-white">
            200+ Leading{" "}
            <span className="bg-gradient-to-r from-[#64a2ff] to-[#064585] bg-clip-text text-transparent">
              Universities &amp; Colleges
            </span>{" "}
          </h1>
          <p className="mt-3 text-sm md:text-base text-slate-300/90 max-w-2xl mx-auto">
            Institutions across India rely on Web_Bocket Classes to empower
            their students with industry-ready skills and practical learning.
          </p>
        </div>

        {/* College grid */}
        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {logos.map((logo, index) => (
            <div
              key={index}
              className={`group relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-3 flex items-center justify-center shadow-lg shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200 ${
                index === 14 ? "hidden md:flex" : "flex"
              }`}
              data-aos="zoom-in"
              data-aos-delay={index * 50}
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-[#064585]/20 via-transparent to-[#5989C8]/10 opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-200" />
              <img
                src={logo}
                alt={`Trusted institute ${index + 1}`}
                className="relative max-h-24 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
